import { useEffect, useRef, useState } from 'react';
import { PRODUCT_IMAGES } from '../../branding/assets';
import './ReservoLP.css';

const SIGNUP_LINK = '/cadastro?produto=reservo';
const LOGIN_LINK = 'https://www.foodstation.app/login';
const LOGO_FULL = PRODUCT_IMAGES.reservo;
const LOGO_ICON = PRODUCT_IMAGES.reservoIcon;
const SCREEN_PUBLIC = '/lp/reservo1.jpeg';
const SCREEN_CALENDAR = '/lp/reservo3.PNG';

const Icon = ({ name, size = 22, stroke = 2, color = 'currentColor' }) => {
  const p = {
    width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
    stroke: color, strokeWidth: stroke, strokeLinecap: 'round', strokeLinejoin: 'round',
  };
  switch (name) {
    case 'check': return <svg {...p}><polyline points="20 6 9 17 4 12" /></svg>;
    case 'x': return <svg {...p}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;
    case 'arrow-right': return <svg {...p}><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>;
    case 'arrow-down': return <svg {...p}><line x1="12" y1="5" x2="12" y2="19" /><polyline points="19 12 12 19 5 12" /></svg>;
    case 'calendar': return <svg {...p}><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>;
    case 'clock': return <svg {...p}><circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 16 14" /></svg>;
    case 'users': return <svg {...p}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>;
    case 'bell': return <svg {...p}><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" /></svg>;
    case 'chart': return <svg {...p}><line x1="12" y1="20" x2="12" y2="10" /><line x1="18" y1="20" x2="18" y2="4" /><line x1="6" y1="20" x2="6" y2="16" /></svg>;
    case 'star': return <svg {...p}><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>;
    case 'shield': return <svg {...p}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>;
    case 'grid': return <svg {...p}><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>;
    case 'phone': return <svg {...p}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>;
    case 'bolt': return <svg {...p}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>;
    case 'lock': return <svg {...p}><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>;
    case 'chev-down': return <svg {...p}><polyline points="6 9 12 15 18 9" /></svg>;
    case 'play': return <svg {...p} fill={color}><polygon points="6 4 20 12 6 20 6 4" /></svg>;
    case 'rocket': return <svg {...p}><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" /><path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" /><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" /></svg>;
    case 'message': return <svg {...p}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>;
    case 'whatsapp': return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.198-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0 0 20.464 3.488" />
      </svg>
    );
    case 'table': return <svg {...p}><rect x="3" y="3" width="18" height="5" rx="1" /><line x1="8" y1="8" x2="8" y2="21" /><line x1="16" y1="8" x2="16" y2="21" /></svg>;
    case 'mail': return <svg {...p}><rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-10 7L2 7" /></svg>;
    case 'repeat': return <svg {...p}><polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" /><polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" /></svg>;
    case 'sparkles': return <svg {...p}><path d="M12 3l1.9 4.6L18.5 9.5l-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9L12 3z" /><path d="M19 14l.95 2.3L22.25 17.25l-2.3.95L19 20.5l-.95-2.3L15.75 17.25l2.3-.95L19 14z" /></svg>;
    case 'fire': return <svg {...p}><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" /></svg>;
    case 'trending': return <svg {...p}><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" /></svg>;
    case 'instagram': return <svg {...p}><rect x="2" y="2" width="20" height="20" rx="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" /></svg>;
    case 'link': return <svg {...p}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></svg>;
    case 'google': return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path d="M21.8 10.4H12v3.2h5.6c-.5 2.4-2.6 3.8-5.6 3.8-3.3 0-6-2.7-6-6s2.7-6 6-6c1.5 0 2.8.5 3.8 1.4l2.4-2.4C16.6 3.1 14.4 2 12 2 6.5 2 2 6.5 2 12s4.5 10 10 10c5.5 0 9.5-3.9 9.5-9.7 0-.6-.1-1.3-.2-1.9z" fill={color} />
      </svg>
    );
    default: return null;
  }
};

const FAQS = [
  { q: 'Preciso de site ou app para oferecer reservas online?', a: 'Não. Você recebe um link personalizado (ex: reservo.app/seu-restaurante) e compartilha onde preferir. O cliente reserva em 2 minutos pelo navegador, sem instalar nada.' },
  { q: 'Como funciona a confirmação automática?', a: 'No dia da reserva é enviado uma mensagem de confirmação por WhatsApp . Reduz no-shows em até 60%, sem trabalho manual.' },
  { q: 'E se eu precisar bloquear horários ou datas?', a: 'Bloqueie feriados, folgas, eventos privados, turnos ou horários específicos com um clique. O sistema impede novas reservas naquele período.' },
  { q: 'Funciona para qualquer tamanho de restaurante?', a: 'Sim. De bares com 5 mesas a casas com 100+ lugares em múltiplos ambientes. O Reservo se adapta ao seu fluxo.' },
  { q: 'Minha equipe consegue acessar as reservas em tempo real?', a: 'Sim. A equipe pode consultar as reservas no sistema, o que ajuda a reduzir falhas de comunicação e evita depender de uma única pessoa para saber o que está reservado.' },
  { q: 'Dá para agrupar mesas para atender reservas maiores?', a: 'Sim. O Reservo permite agrupar mesas para acomodar grupos maiores. Por exemplo, uma reserva de 10 pessoas pode ser organizada juntando duas mesas de 6 lugares, conforme a disponibilidade do salão.' },
  { q: 'Tem fidelidade ou contrato mínimo?', a: 'Não. 7 dias grátis sem cartão. Depois, apenas R$ 79 por mês — cancele quando quiser, sem multa nem burocracia.' },
];

const FEATURES = [
  { icon: 'calendar', n: '01', title: 'Reservas online 24/7', text: 'Link personalizado. Cliente reserva pelo celular em 2 minutos — a qualquer hora.' },
  { icon: 'bell', n: '02', title: 'Confirmação por WhatsApp', text: 'Confirmação imediata + lembretes 24h e 2h antes. Reduz no-shows em até 60%.' },
  { icon: 'users', n: '03', title: 'CRM de clientes', text: 'Frequência, preferências, aniversários. Reconheça clientes fiéis com dados reais.' },
  { icon: 'message', n: '04', title: 'Reservas pelo WhatsApp', text: 'Clientes reservam direto pelo WhatsApp. Sem app, sem cadastro, sem fricção.' },
  { icon: 'chart', n: '05', title: 'Dashboard em tempo real', text: 'Taxa de ocupação, no-shows, horários mais procurados. Decisões com dados reais.' },
  { icon: 'sparkles', n: '06', title: 'E muito mais', text: 'Agrupamento de mesas, pesquisa de satisfação, bloqueio de horários e turnos. Tudo no mesmo lugar.' },
];

const TARGETS = [
  'Perde reserva porque ninguém atende o telefone',
  'Sofre com no-shows que esvaziam mesas no pico',
  'Controla reservas em caderno ou planilha',
  'Quer reservas online, mas não tem site nem TI',
  'Quer reconhecer e fidelizar clientes frequentes',
  'Quer aliviar a equipe sem aumentar custo fixo',
];

const COMPARISON = [
  { without: 'Cliente liga, cai na caixa, reserva no concorrente', with: 'Reserva online em menos de 2 minutos' },
  { without: 'Caderno ilegível, overbooking constante', with: 'Reserva pelo WhatsApp 24/7' },
  { without: 'No-show silencioso destrói a semana', with: '−60% de no-shows com confirmação pelo WhatsApp' },
  { without: 'Clientes anônimos — quem é fiel?', with: 'Relatórios com frequência, preferências e datas' },
  { without: 'Sexta-feira cheia vira caos no salão', with: 'Capacidade controlada automaticamente' },
];

const MARQUEE = [
  '⚡ 7 dias grátis · sem cartão',
  '★ Oferta: de R$ 149 por R$ 79/mês',
  '★ Até −60% de no-shows',
  '⚡ Confirmação por WhatsApp',
  '★ Reservas pelo WhatsApp',
  '⚡ Configuração em minutos',
  '★ Sem fidelidade · cancele quando quiser',
  '⚡ Funciona 24/7 enquanto você dorme',
];

const useReveal = () => {
  useEffect(() => {
    const els = document.querySelectorAll('.rv-lp [data-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(el => el.classList.add('is-revealed')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);
};

const Counter = ({ to, prefix = '', suffix = '', duration = 1400 }) => {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const tick = (now) => {
            const t = Math.min(1, (now - start) / duration);
            const eased = 1 - Math.pow(1 - t, 3);
            setVal(Math.round(eased * to));
            if (t < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      });
    }, { threshold: 0.4 });
    io.observe(node);
    return () => io.disconnect();
  }, [to, duration]);
  return <span ref={ref}>{prefix}{val.toLocaleString('pt-BR')}{suffix}</span>;
};

const ReservoLP = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const [showStickyCta, setShowStickyCta] = useState(false);

  useReveal();

  useEffect(() => {
    document.body.style.overflow = 'hidden scroll';
    document.body.style.scrollbarWidth = 'none';
    document.documentElement.style.setProperty('--scrollbar-display', 'none');
    const style = document.createElement('style');
    style.id = 'rv-lp-no-scrollbar';
    style.textContent = 'body::-webkit-scrollbar { display: none; }';
    document.head.appendChild(style);
    return () => {
      document.body.style.overflow = '';
      document.body.style.scrollbarWidth = '';
      document.getElementById('rv-lp-no-scrollbar')?.remove();
    };
  }, []);

  useEffect(() => {
    const finalSection = document.querySelector('.rv-lp-final');
    let isFinalVisible = false;

    const updateVisibility = () => {
      setShowStickyCta(window.scrollY > 800 && !isFinalVisible);
    };

    const onScroll = () => updateVisibility();
    window.addEventListener('scroll', onScroll, { passive: true });

    let io;
    if (finalSection && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(
        (entries) => {
          isFinalVisible = entries[0].isIntersecting;
          updateVisibility();
        },
        { threshold: 0.05 }
      );
      io.observe(finalSection);
    }

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (io) io.disconnect();
    };
  }, []);

  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'Reservo — Acabe com no-shows e lote seu salão';
    const meta = (name, content, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      const created = !el;
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      const prev = el.getAttribute('content');
      el.setAttribute('content', content);
      return () => { if (created) el.remove(); else if (prev !== null) el.setAttribute('content', prev); };
    };
    const restorers = [
      meta('description', 'Sistema de reservas para restaurantes com editor visual de planta, lembretes automáticos no WhatsApp e CRM completo. Reduza no-shows em até 60%. 7 dias grátis, sem cartão.'),
      meta('og:title', 'Reservo — Sistema de reservas para restaurantes', true),
      meta('og:description', 'Reservas online 24/7, planta visual e lembretes automáticos no WhatsApp. Lote seu salão sem esforço. 7 dias grátis.', true),
    ];
    let canonical = document.head.querySelector('link[rel="canonical"]');
    const createdCanonical = !canonical;
    if (!canonical) { canonical = document.createElement('link'); canonical.setAttribute('rel', 'canonical'); document.head.appendChild(canonical); }
    const prevHref = canonical.getAttribute('href');
    canonical.setAttribute('href', 'https://www.foodstation.app/lp/reservo');
    return () => {
      document.title = prevTitle;
      restorers.forEach(fn => fn());
      if (createdCanonical) canonical.remove();
      else if (prevHref !== null) canonical.setAttribute('href', prevHref);
    };
  }, []);

  // Meta Pixel — carrega o script base uma única vez e registra PageView
  useEffect(() => {
    const PIXEL_ID = '4021127524862051';
    if (!window.fbq) {
      /* eslint-disable */
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */
      window.fbq('init', PIXEL_ID);
    }
    window.fbq('track', 'PageView');
  }, []);

  const toggleFaq = (i) => setOpenFaq(prev => (prev === i ? null : i));

  return (
    <div className="rv-lp">
      {/* Meta Pixel (fallback sem JavaScript) */}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          alt=""
          src="https://www.facebook.com/tr?id=4021127524862051&ev=PageView&noscript=1"
        />
      </noscript>
      {/* ===== TOP MARQUEE STRIP ===== */}
      <div className="rv-lp-marquee">
        <div className="rv-lp-marquee-track">
          {[...Array(3)].map((_, k) => (
            <div className="rv-lp-marquee-group" key={k}>
              {MARQUEE.map((m, i) => (
                <span key={`${k}-${i}`} className="rv-lp-marquee-item">{m}</span>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* ===== NAV ===== */}
      <nav className="rv-lp-nav">
        <div className="rv-lp-nav-inner">
          <a href="#top" className="rv-lp-nav-brand">
            <img src={LOGO_FULL} alt="Reservo" />
          </a>
          <div className="rv-lp-nav-links">
            <a href="#funcionalidades">Funcionalidades</a>
            <a href="#como-funciona">Como funciona</a>
            <a className="rv-lp-nav-cta" href={LOGIN_LINK}>
              Login <Icon name="arrow-right" size={14} stroke={2.5} />
            </a>
          </div>
        </div>
      </nav>

      {/* ===== HERO ===== */}
      <header id="top" className="rv-lp-hero">
        <div className="rv-lp-hero-grain" aria-hidden="true" />
        <div className="rv-lp-hero-inner">
          <div className="rv-lp-hero-top" data-reveal>
            <span className="rv-lp-hero-badge">
              <span className="rv-lp-hero-badge-dot" />
              7 dias grátis · sem cartão · sem fidelidade
            </span>
          </div>
          <h1 className="rv-lp-hero-title" data-reveal>
            Acabe com <span className="rv-lp-hero-strike">mesas vazias</span>
            <br />
            e lote seu salão <span className="rv-lp-hl">sem esforço<span className="rv-lp-hl-mark" /></span>
          </h1>
          <div className="rv-lp-hero-cta" data-reveal>
            <a href={SIGNUP_LINK} className="rv-lp-btn rv-lp-btn-hero-primary">
              Começar 7 dias grátis <Icon name="arrow-right" size={18} stroke={2.5} />
            </a>
            <a href="#video" className="rv-lp-btn rv-lp-btn-ghost">
              <span className="rv-lp-play-circle"><Icon name="play" size={12} color="#0A0A0A" /></span>
              Ver demonstração (90s)
            </a>
          </div>

          {/* ===== HERO MOCKUP COMPOSITION ===== */}
          <div className="rv-lp-hero-mock" data-reveal>
            <div className="rv-lp-hero-mock-phone">
              <div className="rv-lp-phone-notch" />
              <img src={SCREEN_PUBLIC} alt="Página de reservas do Reservo" />
              <div className="rv-lp-hero-mock-badge rv-lp-hero-mock-badge-1">
                <span className="dot green" />
                Nova reserva · 21h
              </div>
              <div className="rv-lp-hero-mock-badge rv-lp-hero-mock-badge-2">
                <Icon name="bell" size={14} color="#0A0A0A" />
                Lembrete enviado ✓
              </div>
            </div>
            <div className="rv-lp-hero-mock-screen">
              <div className="rv-lp-hero-mock-screen-head">
                <span className="rv-lp-hero-mock-dot" />
                <span className="rv-lp-hero-mock-dot" />
                <span className="rv-lp-hero-mock-dot" />
                <span className="rv-lp-hero-mock-url">reservo.app/painel</span>
              </div>
              <img src={SCREEN_CALENDAR} alt="Painel de calendário do Reservo" />
            </div>
            <div className="rv-lp-hero-mock-card">
              <div className="rv-lp-hero-mock-card-head">
                <div className="rv-lp-hero-mock-avatar">A</div>
                <div>
                  <div className="name">Ana Silva</div>
                  <div className="sub">4 pessoas · Mesa 5</div>
                </div>
                <span className="rv-lp-mock-pill">Confirmada</span>
              </div>
              <div className="rv-lp-hero-mock-card-row">
                <Icon name="calendar" size={14} color="#0A0A0A" />
                <span>Sábado · 22h00</span>
              </div>
              <div className="rv-lp-hero-mock-card-row">
                <Icon name="message" size={14} color="#0A0A0A" />
                <span>Lembrete automático em 24h</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* ===== SOCIAL PROOF STRIP ===== */}
      <section className="rv-lp-social">
        <div className="container">
          <div className="rv-lp-social-grid">
            <div className="rv-lp-social-item" data-reveal>
              <div className="big">−<Counter to={60} suffix="%" /></div>
              <div className="lbl">no-shows</div>
            </div>
            <div className="rv-lp-social-item" data-reveal>
              <div className="big"><Counter to={3} suffix="×" /></div>
              <div className="lbl">mais reservas online</div>
            </div>
            <div className="rv-lp-social-item" data-reveal>
              <div className="big"><Counter to={2} />min</div>
              <div className="lbl">o cliente reserva</div>
            </div>
            <div className="rv-lp-social-item" data-reveal>
              <div className="big">24/7</div>
              <div className="lbl">recebendo reservas</div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== PAIN ===== */}
      <section className="rv-lp-section bg-white" style={{paddingTop: '72px'}}>
        <div className="container">
          <div className="rv-lp-head-center" data-reveal>
            <h2 className="rv-lp-h2">
              Cada no-show é <span className="rv-lp-h2-hl">receita perdida</span>
            </h2>
          </div>

          <div className="rv-lp-pain-grid">
            <div className="rv-lp-pain-card" data-reveal>
              <div className="rv-lp-pain-num">01</div>
              <div className="rv-lp-pain-icon"><Icon name="phone" size={26} color="#0A0A0A" /></div>
              <h3>O telefone toca. Ninguém atende</h3>
              <p>Pico do almoço, equipe correndo. O cliente desliga e reserva no concorrente.</p>
            </div>
            <div className="rv-lp-pain-card highlight" data-reveal>
              <div className="rv-lp-pain-num">02</div>
              <div className="rv-lp-pain-icon"><Icon name="users" size={26} color="#0A0A0A" /></div>
              <h3>No-show silencioso no pico</h3>
              <p>Você recusou outras reservas, preparou tudo. A mesa fica vazia. Toda semana.</p>
            </div>
            <div className="rv-lp-pain-card" data-reveal>
              <div className="rv-lp-pain-num">03</div>
              <div className="rv-lp-pain-icon"><Icon name="grid" size={26} color="#0A0A0A" /></div>
              <h3>Caderno não escala</h3>
              <p>Letra ilegível, overbooking constante. Cada erro vira constrangimento no salão.</p>
            </div>
          </div>

          <div className="rv-lp-data" data-reveal>
            <div>
              <h3>Onde restaurantes perdem receita</h3>
              <div className="sub">Causas relatadas por donos e gestores do setor</div>
              <div className="rv-lp-bars">
                {[
                  { label: 'Cliente esquece a reserva (sem lembrete)', pct: 81 },
                  { label: 'No-shows sem aviso prévio', pct: 74 },
                  { label: 'Cliente não consegue reservar fora do expediente', pct: 68 },
                  { label: 'Overbooking por controle manual', pct: 43 },
                ].map((b) => (
                  <div className="rv-lp-bar" key={b.label}>
                    <div className="row">
                      <span>{b.label}</span>
                      <span className="pct">{b.pct}%</span>
                    </div>
                    <div className="track">
                      <div className="fill" style={{ width: `${b.pct}%` }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="rv-lp-stats-cards">
              <div className="rv-lp-stat-card">
                <div className="big">−<Counter to={60} suffix="%" /></div>
                <div className="lbl">de no-shows com confirmações automáticas no WhatsApp</div>
              </div>
              <div className="rv-lp-stat-card alt">
                <div className="big"><Counter to={3} suffix="×" /></div>
                <div className="lbl">mais reservas com link online disponível 24/7</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== PRODUCT SHOWCASE — PUBLIC PAGE ===== */}
      <section className="rv-lp-section bg-white" style={{paddingTop: 0}}>
        <div className="container">
          <div className="rv-lp-showcase-grid reverse">
            <div className="rv-lp-showcase-right" data-reveal>
              <div className="rv-lp-screenshot-phone">
                <div className="rv-lp-phone-notch" />
                <img src={SCREEN_PUBLIC} alt="Página pública de reservas" />
              </div>
              <div className="rv-lp-screenshot-float rv-lp-screenshot-float-1">
                <Icon name="instagram" size={16} color="#0A0A0A" />
                <span>Cole o link no Instagram</span>
              </div>
              <div className="rv-lp-screenshot-float rv-lp-screenshot-float-2">
                <Icon name="link" size={16} color="#0A0A0A" />
                <span>reservo.app/<b>seu-restaurante</b></span>
              </div>
            </div>
            <div className="rv-lp-showcase-left" data-reveal>
              <span className="rv-lp-tag">Página de reservas</span>
              <h2 className="rv-lp-h2">
                Um <span className="rv-lp-h2-hl">link</span> e seu salão começa a lotar
              </h2>
              <p className="rv-lp-section-sub">
                Disponibilize onde seus clientes já estão:
              </p>
              <div className="rv-lp-brand-logos">
                <span className="rv-lp-brand-pill">
                  <Icon name="instagram" size={16} color="#0A0A0A" /> Instagram
                </span>
                <span className="rv-lp-brand-pill">
                  <Icon name="whatsapp" size={16} color="#25D366" /> WhatsApp
                </span>
                <span className="rv-lp-brand-pill">
                  <Icon name="google" size={16} color="#0A0A0A" /> Google
                </span>
              </div>
              <ul className="rv-lp-showcase-list dark">
                {[
                  'Link com o nome do seu restaurante',
                  'Reserva em menos de 2 minutos pelo celular',
                  'Confirmação imediata por WhatsApp',
                  'Zero instalação para o cliente',
                ].map((t, i) => (
                  <li key={i}>
                    <span className="rv-lp-check"><Icon name="check" size={13} stroke={3} color="#0A0A0A" /></span>
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ===== PRODUCT SHOWCASE — CALENDAR ===== */}
      <section className="rv-lp-section bg-black">
        <div className="container">
          <div className="rv-lp-showcase-grid">
            <div className="rv-lp-showcase-left light" data-reveal>
              <span className="rv-lp-tag yellow-on-dark">Painel completo</span>
              <h2 className="rv-lp-h2 white">
                Toda a sua agenda em <span className="rv-lp-h2-hl-yellow">um só lugar</span>
              </h2>
              <p className="rv-lp-section-sub light">
                Calendário visual, bloqueio com um clique, reserva manual e configuração de turnos. <b>Sem caderno, sem planilha.</b>
              </p>
              <ul className="rv-lp-showcase-list light">
                {[
                  'Visão mensal, semanal e diária',
                  'Bloqueio de datas e horários em segundos',
                  'Reserva manual para telefone e walk-in',
                  'Configuração por turno e ambiente',
                ].map((t, i) => (
                  <li key={i}>
                    <span className="rv-lp-check-yellow"><Icon name="check" size={13} stroke={3} color="#0A0A0A" /></span>
                    {t}
                  </li>
                ))}
              </ul>
              <a href={SIGNUP_LINK} className="rv-lp-btn rv-lp-btn-yellow">
                Quero esse painel <Icon name="arrow-right" size={16} stroke={2.5} />
              </a>
            </div>
            <div className="rv-lp-showcase-right" data-reveal>
              <div className="rv-lp-screenshot-wrap">
                <div className="rv-lp-screenshot-glow yellow" />
                <img src={SCREEN_CALENDAR} alt="Painel calendário de reservas" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== ANTES vs DEPOIS ===== */}
      <section className="rv-lp-section bg-off" style={{paddingTop: '72px'}}>
        <div className="container">
          <div className="rv-lp-head-center" data-reveal>
            <h2 className="rv-lp-h2">
              A mesma sexta <span className="rv-lp-h2-hl">Outro resultado</span>
            </h2>
          </div>
          <div className="rv-lp-vs" data-reveal>
            <div className="rv-lp-vs-col rv-lp-vs-bad">
              <div className="rv-lp-vs-head">
                <span className="rv-lp-vs-icon bad"><Icon name="x" size={18} stroke={3} /></span>
                Sem Reservo
              </div>
              <ul>
                {COMPARISON.map((c, i) => (<li key={i}>{c.without}</li>))}
              </ul>
            </div>
            <div className="rv-lp-vs-divider"><span>vs</span></div>
            <div className="rv-lp-vs-col rv-lp-vs-good">
              <div className="rv-lp-vs-head">
                <span className="rv-lp-vs-icon good"><Icon name="check" size={18} stroke={3} /></span>
                Com Reservo
              </div>
              <ul>
                {COMPARISON.map((c, i) => (<li key={i}>{c.with}</li>))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ===== HOW IT WORKS ===== */}
      <section id="como-funciona" className="rv-lp-section bg-white" style={{paddingTop: '72px'}}>
        <div className="container">
          <div className="rv-lp-head-center" data-reveal>
            <h2 className="rv-lp-h2">
              Da inscrição à primeira reserva <span className="rv-lp-h2-hl">em minutos</span>
            </h2>
          </div>
          <div className="rv-lp-steps">
            {[
              { n: 1, t: 'Crie sua conta', d: 'Cadastro em 30 segundos. Sem cartão de crédito.' },
              { n: 2, t: 'Configure em minutos', d: 'Defina turnos, capacidade e horários. Tudo pelo painel.' },
              { n: 3, t: 'Compartilhe o link', d: 'Cole no Instagram, WhatsApp e Google. Pronto.' },
              { n: 4, t: 'Reservo cuida do resto', d: 'Confirmação, lembretes e alterações no automático.' },
            ].map((s) => (
              <div className="rv-lp-step" data-reveal key={s.n}>
                <div className="rv-lp-step-circle">{s.n}</div>
                <h3>{s.t}</h3>
                <p>{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FEATURES — NUMBERED CARDS ===== */}
      <section id="funcionalidades" className="rv-lp-section bg-off" style={{paddingTop: '72px'}}>
        <div className="container">
          <div className="rv-lp-head-center" data-reveal>
            <h2 className="rv-lp-h2">
              Um sistema completo <span className="rv-lp-h2-hl">pra lotar o fim de semana</span>
            </h2>
          </div>
          <div className="rv-lp-features">
            {FEATURES.map((f, i) => (
              <div className={`rv-lp-feature${i === 0 ? ' accent' : ''}`} data-reveal key={i}>
                <div className="rv-lp-feature-num">{f.n}</div>
                <div className="rv-lp-feature-icon"><Icon name={f.icon} size={22} color={i === 0 ? '#FFDB30' : '#0A0A0A'} /></div>
                <h3>{f.title}</h3>
                <p>{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* ===== TARGET ===== */}
      <section className="rv-lp-section bg-off" style={{paddingTop: '72px'}}>
        <div className="container">
          <div className="rv-lp-head-center" data-reveal>
            <h2 className="rv-lp-h2">
              O Reservo é pra <span className="rv-lp-h2-hl">você que...</span>
            </h2>
          </div>
          <div className="rv-lp-target">
            {TARGETS.map((t, i) => (
              <div className="rv-lp-target-card" data-reveal key={i}>
                <span className="rv-lp-target-num">{String(i + 1).padStart(2, '0')}</span>
                <span className="rv-lp-target-text">{t}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== VIDEO ===== */}
      <section id="video" className="rv-lp-section bg-white" style={{paddingTop: '72px'}}>
        <div className="container">
          <div className="rv-lp-head-center" data-reveal>
            <h2 className="rv-lp-h2">
              Em <span className="rv-lp-h2-hl">90 segundos</span> você entende tudo
            </h2>
          </div>
          <div className="rv-lp-video-single" data-reveal>
            <div className="rv-lp-video-frame">
              <iframe
                src="https://www.youtube.com/embed/1KaSXtyebG8"
                title="Reservo — Como funciona"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </section>

      {/* ===== TRIAL CTA BANNER ===== */}
      <section className="rv-lp-trial bg-yellow">
        <div className="container">
          <div className="rv-lp-trial-grid" data-reveal>
            <div className="rv-lp-trial-text">
              <div className="rv-lp-trial-eyebrow">Comece hoje</div>
              <h2 className="rv-lp-trial-title">
                7 dias grátis<br />Sem cartão<br /><span className="rv-lp-trial-highlight">Sem pegadinha</span>
              </h2>
              <div className="rv-lp-trial-price" aria-label="De 149 reais por 79 reais por mês">
                <span className="rv-lp-trial-price-old">de R$ 149</span>
                <div className="rv-lp-trial-price-current">
                  <span className="rv-lp-trial-price-currency">R$</span>
                  <strong>79</strong>
                  <span className="rv-lp-trial-price-period">/mês</span>
                </div>
              </div>
              <p className="rv-lp-trial-sub">
                Configure seu salão. Receba reservas. Se não rolar, não cobramos um centavo.
              </p>
              <div className="rv-lp-trial-list">
                {[
                  'Reservas online ilimitadas',
                  'Confirmação no WhatsApp',
                  'Reservas pelo WhatsApp',
                  'Dashboard em tempo real',
                ].map((t, i) => (
                  <div className="rv-lp-trial-list-item" key={i}>
                    <span className="rv-lp-check-dark"><Icon name="check" size={13} stroke={3} color="#FFDB30" /></span>
                    {t}
                  </div>
                ))}
              </div>
            </div>
            <div className="rv-lp-trial-art" aria-hidden="true">
              <div className="rv-lp-trial-art-circle">
                <img src={LOGO_ICON} alt="" />
                <div className="rv-lp-trial-art-orbit">
                  <span className="rv-lp-trial-art-orbit-dot" style={{ '--i': 0 }}><Icon name="calendar" size={20} color="#0A0A0A" /></span>
                  <span className="rv-lp-trial-art-orbit-dot" style={{ '--i': 1 }}><Icon name="bell" size={20} color="#0A0A0A" /></span>
                  <span className="rv-lp-trial-art-orbit-dot" style={{ '--i': 2 }}><Icon name="users" size={20} color="#0A0A0A" /></span>
                  <span className="rv-lp-trial-art-orbit-dot" style={{ '--i': 3 }}><Icon name="message" size={20} color="#0A0A0A" /></span>
                </div>
              </div>
              <div className="rv-lp-trial-art-tag tag-1"><b>7 dias grátis</b></div>
              <div className="rv-lp-trial-art-tag tag-2">Sem fidelidade</div>
              <div className="rv-lp-trial-art-tag tag-3">Cancele quando quiser</div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FAQ ===== */}
      <section id="faq" className="rv-lp-section bg-white" style={{ paddingTop: '72px' }}>
        <div className="container">
          <div className="rv-lp-head-center" data-reveal>
            <h2 className="rv-lp-h2">
              Ainda tem <span className="rv-lp-h2-hl">dúvidas?</span>
            </h2>
          </div>
          <div className="rv-lp-faq-list">
            {FAQS.map((item, i) => (
              <div className={`rv-lp-faq-item${openFaq === i ? ' open' : ''}`} key={i}>
                <button
                  type="button"
                  className="rv-lp-faq-q"
                  aria-expanded={openFaq === i}
                  onClick={() => toggleFaq(i)}
                >
                  <span className="rv-lp-faq-q-num">{String(i + 1).padStart(2, '0')}</span>
                  <span className="rv-lp-faq-q-text">{item.q}</span>
                  <span className="chev"><Icon name="chev-down" size={20} /></span>
                </button>
                <div className="rv-lp-faq-a-wrap">
                  <div className="rv-lp-faq-a">{item.a}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FINAL CTA — GIANT ===== */}
      <section className="rv-lp-final">
        <div className="rv-lp-final-grain" aria-hidden="true" />
        <div className="container">
          <div data-reveal style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <div className="rv-lp-final-eyebrow">
              <span className="rv-lp-final-dot" />
              Pronto pra parar de perder mesa?
            </div>
            <h2 className="rv-lp-final-title">
              Lote seu salão
              <br />
              <span className="rv-lp-final-hl">Acabe com no-shows</span>
            </h2>
            <p className="rv-lp-final-sub">
              Configure em minutos. Receba reservas ainda hoje.
            </p>
            <a href={SIGNUP_LINK} className="rv-lp-btn rv-lp-btn-massive">
              Começar 7 dias grátis <Icon name="arrow-right" size={22} stroke={2.5} />
            </a>
            <div className="rv-lp-final-trust">
              <span><Icon name="check" size={14} stroke={3} color="#FFDB30" /> Sem cartão de crédito</span>
              <span><Icon name="check" size={14} stroke={3} color="#FFDB30" /> Sem fidelidade</span>
              <span><Icon name="check" size={14} stroke={3} color="#FFDB30" /> Cancele quando quiser</span>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="rv-lp-footer">
        <div className="rv-lp-footer-inner">
          <div className="rv-lp-footer-brand">
            <img src={LOGO_FULL} alt="Reservo" />
            <span className="by">by FoodStation</span>
          </div>
          <div className="rv-lp-footer-copy">© 2025 FoodStation. Todos os direitos reservados.</div>
          <div className="rv-lp-footer-lgpd">
            <span className="lock"><Icon name="lock" size={14} /></span>
            Dados protegidos pela LGPD
          </div>
        </div>
      </footer>

      {/* ===== STICKY CTA ===== */}
      <a
        href={SIGNUP_LINK}
        className={`rv-lp-sticky-cta${showStickyCta ? ' is-visible' : ''}`}
        aria-label="Começar 7 dias grátis"
      >
        <Icon name="calendar" size={18} />
        <span>7 dias grátis · depois R$ 79/mês</span>
      </a>

    </div>
  );
};

export default ReservoLP;
